<template>
  <div class="page-content">
    <div class="container py-12">
      <!-- 会议室选择区域 -->
      <section class="mb-16">
        <h2 class="section-title">选择会议室</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 room-grid">
          <!-- 会议室202 -->
          <div class="room-card selected">
            <div class="room-card-header">
              <i class="fas fa-door-open mr-2"></i>会议室 202
            </div>
            <div class="room-card-body">
              <div class="room-info">
                <span class="room-info-label">楼层：</span>
                <span class="room-info-value">2F</span>
              </div>
              <div class="room-info">
                <span class="room-info-label">面积：</span>
                <span class="room-info-value">162 m²</span>
              </div>
              <div class="room-info">
                <span class="room-info-label">尺寸：</span>
                <span class="room-info-value">18×9×2.8 m</span>
              </div>
              <div class="capacity-grid">
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-church"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">剧场式</div>
                    <div class="font-medium">120人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-graduation-cap"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">课桌式</div>
                    <div class="font-medium">80人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-utensils"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">宴会式</div>
                    <div class="font-medium">84人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-th-large"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">口型</div>
                    <div class="font-medium">48人</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 会议室202A -->
          <div class="room-card">
            <div class="room-card-header">
              <i class="fas fa-door-open mr-2"></i>会议室 202A
            </div>
            <div class="room-card-body">
              <div class="room-info">
                <span class="room-info-label">楼层：</span>
                <span class="room-info-value">2F</span>
              </div>
              <div class="room-info">
                <span class="room-info-label">面积：</span>
                <span class="room-info-value">81 m²</span>
              </div>
              <div class="room-info">
                <span class="room-info-label">尺寸：</span>
                <span class="room-info-value">9×9×2.8 m</span>
              </div>
              <div class="capacity-grid">
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-church"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">剧场式</div>
                    <div class="font-medium">70人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-graduation-cap"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">课桌式</div>
                    <div class="font-medium">48人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-utensils"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">宴会式</div>
                    <div class="font-medium">36人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-th-large"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">口型</div>
                    <div class="font-medium">30人</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 会议室202B -->
          <div class="room-card">
            <div class="room-card-header">
              <i class="fas fa-door-open mr-2"></i>会议室 202B
            </div>
            <div class="room-card-body">
              <div class="room-info">
                <span class="room-info-label">楼层：</span>
                <span class="room-info-value">2F</span>
              </div>
              <div class="room-info">
                <span class="room-info-label">面积：</span>
                <span class="room-info-value">81 m²</span>
              </div>
              <div class="room-info">
                <span class="room-info-label">尺寸：</span>
                <span class="room-info-value">9×9×2.8 m</span>
              </div>
              <div class="capacity-grid">
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-church"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">剧场式</div>
                    <div class="font-medium">70人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-graduation-cap"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">课桌式</div>
                    <div class="font-medium">48人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-utensils"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">宴会式</div>
                    <div class="font-medium">36人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-th-large"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">口型</div>
                    <div class="font-medium">30人</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 会议室203 -->
          <div class="room-card">
            <div class="room-card-header">
              <i class="fas fa-door-open mr-2"></i>会议室 203
            </div>
            <div class="room-card-body">
              <div class="room-info">
                <span class="room-info-label">楼层：</span>
                <span class="room-info-value">2F</span>
              </div>
              <div class="room-info">
                <span class="room-info-label">面积：</span>
                <span class="room-info-value">162 m²</span>
              </div>
              <div class="room-info">
                <span class="room-info-label">尺寸：</span>
                <span class="room-info-value">18×9×2.8 m</span>
              </div>
              <div class="capacity-grid">
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-church"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">剧场式</div>
                    <div class="font-medium">120人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-graduation-cap"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">课桌式</div>
                    <div class="font-medium">80人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-utensils"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">宴会式</div>
                    <div class="font-medium">84人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-th-large"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">口型</div>
                    <div class="font-medium">48人</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 会议室203A -->
          <div class="room-card">
            <div class="room-card-header">
              <i class="fas fa-door-open mr-2"></i>会议室 203A
            </div>
            <div class="room-card-body">
              <div class="room-info">
                <span class="room-info-label">楼层：</span>
                <span class="room-info-value">2F</span>
              </div>
              <div class="room-info">
                <span class="room-info-label">面积：</span>
                <span class="room-info-value">81 m²</span>
              </div>
              <div class="room-info">
                <span class="room-info-label">尺寸：</span>
                <span class="room-info-value">9×9×2.8 m</span>
              </div>
              <div class="capacity-grid">
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-church"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">剧场式</div>
                    <div class="font-medium">70人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-graduation-cap"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">课桌式</div>
                    <div class="font-medium">48人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-utensils"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">宴会式</div>
                    <div class="font-medium">36人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-th-large"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">口型</div>
                    <div class="font-medium">30人</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 会议室203B -->
          <div class="room-card">
            <div class="room-card-header">
              <i class="fas fa-door-open mr-2"></i>会议室 203B
            </div>
            <div class="room-card-body">
              <div class="room-info">
                <span class="room-info-label">楼层：</span>
                <span class="room-info-value">2F</span>
              </div>
              <div class="room-info">
                <span class="room-info-label">面积：</span>
                <span class="room-info-value">81 m²</span>
              </div>
              <div class="room-info">
                <span class="room-info-label">尺寸：</span>
                <span class="room-info-value">9×9×2.8 m</span>
              </div>
              <div class="capacity-grid">
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-church"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">剧场式</div>
                    <div class="font-medium">70人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-graduation-cap"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">课桌式</div>
                    <div class="font-medium">48人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-utensils"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">宴会式</div>
                    <div class="font-medium">36人</div>
                  </div>
                </div>
                <div class="capacity-item">
                  <div class="capacity-icon"><i class="fas fa-th-large"></i></div>
                  <div>
                    <div class="text-sm text-gray-500">口型</div>
                    <div class="font-medium">30人</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 预订信息输入区域 -->
      <section>
        <h2 class="section-title">填报信息</h2>
        <div class="form-container">
          <h2 class="form-title">
            <i class="fas fa-calendar-check"></i>预订会议室
          </h2>

          <form>
            <div class="form-row">
              <div class="form-col">
                <div class="form-group">
                  <label for="name" class="form-label">姓名</label>
                  <input type="text" id="name" class="form-input" placeholder="请输入您的姓名">
                </div>
              </div>
              <div class="form-col">
                <div class="form-group">
                  <label for="phone" class="form-label">电话</label>
                  <input type="tel" id="phone" class="form-input" placeholder="请输入您的联系电话">
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">使用时段</label>
              <div class="time-picker-container">
                <div class="time-picker-group">
                  <input type="datetime-local" class="form-input" placeholder="开始时间">
                </div>
                <div class="time-picker-group">
                  <input type="datetime-local" class="form-input" placeholder="结束时间">
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-col">
                <div class="form-group">
                  <label for="people" class="form-label">预计人数</label>
                  <input type="number" id="people" class="form-input" placeholder="请输入预计人数">
                </div>
              </div>
              <div class="form-col">
                <div class="form-group">
                  <label for="area" class="form-label">预计面积</label>
                  <select id="area" class="form-select">
                    <option value="">请选择面积范围</option>
                    <option value="small">50㎡以下</option>
                    <option value="medium">50-100㎡</option>
                    <option value="large">100-200㎡</option>
                    <option value="xlarge">200㎡以上</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="layout" class="form-label">摆台形式</label>
              <select id="layout" class="form-select">
                <option value="">请选择摆台形式</option>
                <option value="theater">剧场式</option>
                <option value="classroom">课桌式</option>
                <option value="banquet">宴会式</option>
                <option value="u-shape">口型</option>
              </select>
            </div>

            <div class="form-group">
              <label class="form-label">配套服务</label>
              <div class="form-checkbox-group">
                <div class="form-checkbox-item">
                  <input type="checkbox" id="service1" class="form-checkbox">
                  <label for="service1">投影仪</label>
                </div>
                <div class="form-checkbox-item">
                  <input type="checkbox" id="service2" class="form-checkbox">
                  <label for="service2">音响设备</label>
                </div>
                <div class="form-checkbox-item">
                  <input type="checkbox" id="service3" class="form-checkbox">
                  <label for="service3">白板</label>
                </div>
                <div class="form-checkbox-item">
                  <input type="checkbox" id="service4" class="form-checkbox">
                  <label for="service4">茶水服务</label>
                </div>
                <div class="form-checkbox-item">
                  <input type="checkbox" id="service5" class="form-checkbox">
                  <label for="service5">点心服务</label>
                </div>
                <div class="form-checkbox-item">
                  <input type="checkbox" id="service6" class="form-checkbox">
                  <label for="service6">视频会议</label>
                </div>
              </div>
            </div>

            <div class="form-group">
              <button type="button" class="submit-button">
                <i class="fas fa-check-circle mr-2"></i>提交预订
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line no-undef
tailwind.config = {
  theme: {
    extend: {
      colors: {
        primary: '#2563EB',
        secondary: '#204E9C',
        accent: '#60A3BC',
        light: '#F5F7FA',
        dark: '#0C2461'
      },
      fontFamily: {
        sans: ['Inter', 'system-ui', 'sans-serif'],
      },
    }
  }
}
export default {
  name: "Hysyd",
  mounted() {
      // 会议室卡片点击效果
      const roomCards = document.querySelectorAll('.room-card');
      roomCards.forEach(card => {
        card.addEventListener('click', function() {
          // 移除所有卡片的选中状态
          roomCards.forEach(c => {
            c.classList.remove('selected');
          });
          // 添加当前卡片的选中状态
          this.classList.add('selected');
        });
      });

      // 表单提交按钮点击事件
      const submitButton = document.querySelector('.submit-button');
      submitButton.addEventListener('click', function() {
        alert('预订信息已提交，我们将尽快与您联系确认！');
      });
  },
  methods: {
    openRouter(url){
      const { href } = this.$router.resolve({
        path: url,
        query:{}
      });
      window.open(href, '_blank', 'noopener');
    },
  }
}
</script>

<style scoped>
.bg-gradient-primary {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  border-radius: 20px 20px 0px 0px;
  margin-bottom: 20px;
}

.page-content{
  padding-top: 20px;
  padding-bottom: 20px;
}
body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  background-color: #F9FAFB;
  color: #1F2937;
  line-height: 1.5;
}

.container {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 20px;
}

.room-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.room-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.room-card.selected {
  border: 2px solid #2563EB;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.room-card-header {
  background-color: #2563EB;
  color: white;
  padding: 16px 20px;
  font-weight: 600;
  font-size: 1.25rem;
}

.room-card-body {
  padding: 20px;
  background-color: white;
}

.capacity-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 16px;
}

.capacity-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #F3F4F6;
  border-radius: 6px;
}

.capacity-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  color: #2563EB;
}

.form-container {
  background-color: white;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.form-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1F2937;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
}

.form-title i {
  color: #2563EB;
  margin-right: 12px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.form-input, .form-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease;
}

.form-input:focus, .form-select:focus {
  outline: none;
  border-color: #2563EB;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.form-checkbox-item {
  display: flex;
  align-items: center;
}

.form-checkbox {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  accent-color: #2563EB;
}

.submit-button {
  background-color: #2563EB;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.submit-button:hover {
  background-color: #204E9C;
}

.section-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1F2937;
  margin-bottom: 24px;
  text-align: center;
}

.room-info {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.room-info-label {
  width: 80px;
  font-weight: 500;
  color: #4B5563;
}

.room-info-value {
  color: #1F2937;
}

.time-picker-container {
  display: flex;
  gap: 12px;
}

.time-picker-group {
  flex: 1;
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-col {
  flex: 1;
}

/* Banner样式 */
.banner {
  background-color: #2563EB;
  color: white;
  padding: 40px 0;
  margin-bottom: 30px;
  text-align: center;
}

.banner-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 12px;
}

.banner-description {
  font-size: 1.125rem;
  opacity: 0.9;
  max-width: 800px;
  margin: 0 auto;
}

@media (max-width: 1200px) {
  .container {
    padding: 0 16px;
  }

  .room-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .room-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .form-row {
    flex-direction: column;
  }

  .time-picker-container {
    flex-direction: column;
  }

  .banner-title {
    font-size: 2rem;
  }

  .banner-description {
    font-size: 1rem;
  }
}

@media (max-width: 640px) {
  .room-grid {
    grid-template-columns: 1fr;
  }

  .form-container {
    padding: 20px;
  }

  .banner {
    padding: 30px 0;
  }

  .banner-title {
    font-size: 1.75rem;
  }
}
</style>
